// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * cdr-shared-api
 * Shared API Gateway for all CDR endpoints
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface MyAccessResponse
 */
export interface MyAccessResponse {
    /**
     * Audiences of every capability set the caller's token maps to
     * @type {Array<string>}
     * @memberof MyAccessResponse
     */
    audiences: Array<MyAccessResponseAudiencesEnum>;
    /**
     * The caller's normalized email claim
     * @type {string}
     * @memberof MyAccessResponse
     */
    email: string;
    /**
     * The caller's principal id, or null when CDR has no principal for them
     * @type {string}
     * @memberof MyAccessResponse
     */
    principal_id: string | null;
    /**
     * Capabilities of every set the caller's token maps to. A resource-scoped set's capabilities apply only where a grant places it
     * @type {Array<string>}
     * @memberof MyAccessResponse
     */
    set_capabilities: Array<string>;
    /**
     * Capabilities of the tenant-scoped sets the caller's token maps to
     * @type {Array<string>}
     * @memberof MyAccessResponse
     */
    tenant_capabilities: Array<string>;
}


/**
 * @export
 */
export const MyAccessResponseAudiencesEnum = {
    Internal: 'internal',
    External: 'external'
} as const;
export type MyAccessResponseAudiencesEnum = typeof MyAccessResponseAudiencesEnum[keyof typeof MyAccessResponseAudiencesEnum];


/**
 * Check if a given object implements the MyAccessResponse interface.
 */
export function instanceOfMyAccessResponse(value: object): value is MyAccessResponse {
    if (!('audiences' in value) || value['audiences'] === undefined) return false;
    if (!('email' in value) || value['email'] === undefined) return false;
    if (!('principal_id' in value) || value['principal_id'] === undefined) return false;
    if (!('set_capabilities' in value) || value['set_capabilities'] === undefined) return false;
    if (!('tenant_capabilities' in value) || value['tenant_capabilities'] === undefined) return false;
    return true;
}

export function MyAccessResponseFromJSON(json: any): MyAccessResponse {
    return MyAccessResponseFromJSONTyped(json, false);
}

export function MyAccessResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): MyAccessResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'audiences': json['audiences'],
        'email': json['email'],
        'principal_id': json['principal_id'],
        'set_capabilities': json['set_capabilities'],
        'tenant_capabilities': json['tenant_capabilities'],
    };
}

export function MyAccessResponseToJSON(json: any): MyAccessResponse {
    return MyAccessResponseToJSONTyped(json, false);
}

export function MyAccessResponseToJSONTyped(value?: MyAccessResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'audiences': value['audiences'],
        'email': value['email'],
        'principal_id': value['principal_id'],
        'set_capabilities': value['set_capabilities'],
        'tenant_capabilities': value['tenant_capabilities'],
    };
}
